import script from "./ResumoStatusNoticias.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumoStatusNoticias.vue?vue&type=script&setup=true&lang=js"

import "./ResumoStatusNoticias.vue?vue&type=style&index=0&id=ffa4b78a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa4b78a"]])

export default __exports__